import { mdiCheckCircle, mdiKey } from '@mdi/js';
import Icon from '@mdi/react';
import React from 'react';

const TextInput = ({
  name,
  type,
  onChange,
  onKeyDown,
  disabled,
  readOnly,
  defaultValue,
  placeholder,
  label,
  style,
}) => (
  <div className='field'>
    {label && label !== 'noLabel' && (
      <label className='label' htmlFor={name}>
        {label}
      </label>
    )}
    <div className='control'>
      <input
        className='input is-size-6'
        id={name}
        readOnly={readOnly}
        onChange={onChange}
        onKeyDown={onKeyDown}
        value={defaultValue}
        type={type}
        disabled={disabled}
        placeholder={placeholder}
        style={{ ...style }}
      />
    </div>
  </div>
);

export default function MViewSummaryAnswerFormListItems(props) {
  const {
    // auth,
    // scope,
    state,
    question,
    onChangeInput,
    handleEnter,
    isEdit,
    roundNumber,
    // index,
  } = props;

  let item = state && state.find((i) => i.key + '' === question.key + '');

  let optionQuestion =
    question && question.questionType === 'optionQuestion' ? true : false;
  let isShortLongQuestion =
    question &&
    (question.questionType === 'shortQuestion' ||
      question.questionType === 'longQuestion')
      ? true
      : false;
  let options = question && question.options;

  let isChecked =
    item && item.isCorrect ? (
      <span className='icon is-small has-text-info ml-1'>
        <Icon path={mdiCheckCircle} size={1} />
      </span>
    ) : (
      ''
    );

  let questionDetail = optionQuestion ? (
    <>
      <p>{question?.question}</p>
      <p style={{ marginTop: -10 }}>
        {options.map((i, index) => (
          <span key={index} className='c-tag'>
            {i}
          </span>
        ))}
      </p>
    </>
  ) : (
    <p>{question?.question}</p>
  );

  let fnSc =
    item?.finalScore && !isNaN(item?.finalScore)
      ? roundNumber(item?.finalScore)
      : item?.finalScore;

  return (
    <tr>
      <td className='has-text-centered middle'>{item?.no}</td>
      <td className='middle'>{questionDetail}</td>
      <td className='middle'>
        <span className='flex align-center'>
          {item?.stAns} {isChecked}{' '}
          {isShortLongQuestion && !item?.isCorrect && (item?.score === 0 || item?.score) && (
            <span className='c-tag ml-1'>
              {Math.round((item?.score + Number.EPSILON) * 100) / 100}
            </span>
          )}
        </span>{' '}
        <div className='mt-2'>
          <span
            className='c-tag'
            style={{ position: 'relative', width: 'max-content' }}
          >
            <span
              className='icon is-small'
              style={{ position: 'absolute', top: 2 }}
            >
              <Icon path={mdiKey} size={1} />
            </span>{' '}
            : <span className='pl-4'>{item?.keyAns}</span>
          </span>
        </div>
      </td>
      <td className='middle has-text-right'>
        {!isEdit && fnSc}
        {isEdit && (
          <div className='flex flex-column justify-center align-center'>
            <span>{question.questionType === 'optionQuestion' || question.questionType === 'optionQuestion' ? 'Bobot Nilai 1' : question.questionType === 'shortQuestion' ? 'Bobot Nilai 2' : 'Bobot Nilai 3' }</span>
            <TextInput
              name={item?.no + '_score'}
              style={{ textAlign: 'right', minWidth: 90 }}
              defaultValue={item?.finalScore ?? 0}
              onKeyDown={(e) => handleEnter(e)}
              onChange={(e) => onChangeInput(e, item, question.questionType)}
              placeholder='ex: 80'
              label='noLabel'
            />
          </div>
        )}
      </td>
    </tr>
  );
}
